// Full-document render of the stearns WriteReviewPage: PageSkeleton (the React
// document shell) wrapping the customer-review__header container around the
// shared write-review SPA. The page is embedded in third-party iframes, so the
// model keeps its @xframe_options_exempt serve override.
//
// The iovation scripts are page-scoped here (legacy included
// `tsicommon/reviews/iovation.html` only on this page; stearns' PageSkeleton does
// not render iovation globally). They are injected imperatively from a
// post-hydration effect (IovationScripts) to keep the IGLOO -> snare -> loader
// execution order under React 19.
import React from "react";
import { IovationScripts } from "tsi-common-react/src/components/IovationScripts/index";

import { Context, templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { Template as WriteReviewSPA } from "./WriteReviewTemplate";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The SPA island accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.WriteReviewPageDocumentTemplate,
): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="customer-review__header">
                <WriteReviewSPA {...props} />
            </div>
            <IovationScripts
                iovationUrl={props.iovation_url}
                staticBase={chrome.static_base}
            />
        </PageSkeleton>
    );
};
